(function() {
/* Mobile: skip custom cursor entirely — no canvas, no rAF, no event listeners */
if(window.innerWidth<768||"ontouchstart"in window){return;}

  'use strict';

  var CURSOR_CONFIG = {
    dotSize: 8,
    dotHoverSize: 14,
    dotColor: '#2D4A3E',
    dotHoverColor: '#C8A96E',
    dotGlowColor: 'rgba(200, 169, 110, 0.45)',
    particleColors: ['#C8A96E', '#4A7C6A', 'rgba(245, 240, 232, 0.6)'],
    particleMinSize: 2,
    particleMaxSize: 5,
    particleFadeTime: [560, 980],
    particleSpreadAngle: 30,
    emitInterval: 17,
    maxParticles: 80,
    lerpSpeed: 0.15,
    gravity: 0.02
  };

  if (!window.matchMedia('(pointer: fine)').matches) return;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reducedMotion = prefersReducedMotion.matches;
  if (reducedMotion) return;
  prefersReducedMotion.addEventListener('change', function(e) {
    reducedMotion = e.matches;
    if (reducedMotion) cleanup();
  });

  var canvas = document.createElement('canvas');
  canvas.id = 'pp-cursor-canvas';
  canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999;';
  document.body.appendChild(canvas);
  var ctx = canvas.getContext('2d');
  var dpr = window.devicePixelRatio || 1;

  function resizeCanvas() {
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resizeCanvas();
  var _resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(_resizeTimer);
    _resizeTimer = setTimeout(resizeCanvas, 150);
  });


  var mouseX = -100, mouseY = -100;
  var cursorX = -100, cursorY = -100;
  var prevMouseX = -100, prevMouseY = -100;
  var velocityX = 0, velocityY = 0;
  var isHovering = false;
  var isVisible = false;
  var currentDotSize = CURSOR_CONFIG.dotSize;
  var currentDotColor = CURSOR_CONFIG.dotColor;
  var lastEmitTime = 0;
  var animFrameId = null;

  var particles = [];
  for (var i = 0; i < CURSOR_CONFIG.maxParticles; i++) {
    particles.push({ alive: false, x: 0, y: 0, vx: 0, vy: 0, size: 0, startSize: 0, color: '', life: 0, maxLife: 0, alpha: 1 });
  }

  function getDeadParticle() {
    for (var i = 0; i < particles.length; i++) {
      if (!particles[i].alive) return particles[i];
    }
    var oldest = particles[0], lowestRatio = 1;
    for (var j = 0; j < particles.length; j++) {
      var ratio = particles[j].life / particles[j].maxLife;
      if (ratio < lowestRatio) { lowestRatio = ratio; oldest = particles[j]; }
    }
    return oldest;
  }

  function emitParticle(x, y, vx, vy) {
    var p = getDeadParticle();
    var speed = Math.sqrt(vx * vx + vy * vy);
    if (speed < 0.5) return;
    var angle = Math.atan2(-vy, -vx);
    var spreadRad = CURSOR_CONFIG.particleSpreadAngle * (Math.PI / 180);
    angle += (Math.random() - 0.5) * 2 * spreadRad;
    var launchSpeed = Math.min(speed * 0.3, 4) + Math.random() * 1.5;
    p.alive = true; p.x = x; p.y = y;
    p.vx = Math.cos(angle) * launchSpeed;
    p.vy = Math.sin(angle) * launchSpeed;
    p.startSize = CURSOR_CONFIG.particleMinSize + Math.random() * (CURSOR_CONFIG.particleMaxSize - CURSOR_CONFIG.particleMinSize);
    p.size = p.startSize;
    p.color = CURSOR_CONFIG.particleColors[Math.floor(Math.random() * CURSOR_CONFIG.particleColors.length)];
    p.maxLife = CURSOR_CONFIG.particleFadeTime[0] + Math.random() * (CURSOR_CONFIG.particleFadeTime[1] - CURSOR_CONFIG.particleFadeTime[0]);
    p.life = p.maxLife; p.alpha = 1;
  }

  function onMouseMove(e) { mouseX = e.clientX; mouseY = e.clientY; if (!isVisible) isVisible = true; }
  function onMouseEnter() { isVisible = true; }
  function onMouseLeave() { isVisible = false; }
  var hoverSelectors = 'a, button, [role="button"], .clickable, input[type="submit"], input[type="button"], label[for], select, [onclick], .btn, .add-to-cart-btn, .toggle-btn, .tier-pill';
  function onMouseOver(e) { if (e.target && e.target.closest && e.target.closest(hoverSelectors)) isHovering = true; }
  function onMouseOut(e) { if (e.target && e.target.closest && e.target.closest(hoverSelectors)) isHovering = false; }

  document.addEventListener('mousemove', onMouseMove, { passive: true });
  document.addEventListener('mouseenter', onMouseEnter);
  document.addEventListener('mouseleave', onMouseLeave);
  document.addEventListener('mouseover', onMouseOver, { passive: true });
  document.addEventListener('mouseout', onMouseOut, { passive: true });

  function lerp(a, b, t) { return a + (b - a) * t; }
  function hexToRgb(hex) {
    if (hex.charAt(0) === '#') hex = hex.substring(1);
    var bigint = parseInt(hex, 16);
    return { r: (bigint >> 16) & 255, g: (bigint >> 8) & 255, b: bigint & 255 };
  }
  var dotColorRgb = hexToRgb(CURSOR_CONFIG.dotColor);
  var hoverColorRgb = hexToRgb(CURSOR_CONFIG.dotHoverColor);
  function lerpColor(c1, c2, t) {
    return { r: Math.round(lerp(c1.r, c2.r, t)), g: Math.round(lerp(c1.g, c2.g, t)), b: Math.round(lerp(c1.b, c2.b, t)) };
  }

  var lastTime = performance.now();
  var hoverT = 0;

  function render(now) {
    animFrameId = requestAnimationFrame(render);
    if (document.hidden) return;
    var dt = now - lastTime; lastTime = now;
    if (dt > 100) dt = 16;

    cursorX = lerp(cursorX, mouseX, CURSOR_CONFIG.lerpSpeed);
    cursorY = lerp(cursorY, mouseY, CURSOR_CONFIG.lerpSpeed);
    velocityX = mouseX - prevMouseX; velocityY = mouseY - prevMouseY;
    prevMouseX = mouseX; prevMouseY = mouseY;

    var hoverTarget = isHovering ? 1 : 0;
    hoverT = lerp(hoverT, hoverTarget, 0.12);
    currentDotSize = lerp(CURSOR_CONFIG.dotSize, CURSOR_CONFIG.dotHoverSize, hoverT);
    var blendedColor = lerpColor(dotColorRgb, hoverColorRgb, hoverT);
    currentDotColor = 'rgb(' + blendedColor.r + ',' + blendedColor.g + ',' + blendedColor.b + ')';

    var speed = Math.sqrt(velocityX * velocityX + velocityY * velocityY);
    if (speed > 1 && isVisible && (now - lastEmitTime) > CURSOR_CONFIG.emitInterval) {
      emitParticle(cursorX, cursorY, velocityX, velocityY);
      lastEmitTime = now;
    }

    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      if (!p.alive) continue;
      p.life -= dt;
      if (p.life <= 0) { p.alive = false; continue; }
      var lifeRatio = p.life / p.maxLife;
      p.alpha = lifeRatio; p.size = p.startSize * lifeRatio;
      p.vy += CURSOR_CONFIG.gravity; p.vx *= 0.98; p.vy *= 0.98;
      p.x += p.vx; p.y += p.vy;
    }

    ctx.clearRect(0, 0, canvas.width / dpr, canvas.height / dpr);

    for (var j = 0; j < particles.length; j++) {
      var pt = particles[j];
      if (!pt.alive || pt.alpha <= 0.01) continue;
      ctx.save(); ctx.globalAlpha = pt.alpha;
      ctx.beginPath(); ctx.arc(pt.x, pt.y, pt.size * 0.5, 0, Math.PI * 2);
      ctx.fillStyle = pt.color; ctx.fill(); ctx.restore();
    }

  }

  animFrameId = requestAnimationFrame(render);

  function cleanup() {
    if (animFrameId) cancelAnimationFrame(animFrameId);
    if (canvas && canvas.parentNode) canvas.parentNode.removeChild(canvas);
    if (cursorStyle && cursorStyle.parentNode) cursorStyle.parentNode.removeChild(cursorStyle);
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseenter', onMouseEnter);
    document.removeEventListener('mouseleave', onMouseLeave);
    document.removeEventListener('mouseover', onMouseOver);
    document.removeEventListener('mouseout', onMouseOut);
  }
})();